import React, { useEffect } from 'react';
import './styles/App.scss';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NavbarHeader from './components/navigation';
import ScrollToTop from "./components/ScrollToTop";
import ScrollToHashElement from "@cascadia-code/scroll-to-hash-element";
// Pages Jeunes
import HomeYoung from './Pages/Jeunes/HomeYoung';
import AllOnPeriods from './Pages/Jeunes/AllOnPeriods';
import SpecificVideo from './Pages/Jeunes/SpecificVideo';
import QuestionsUsers from './Pages/Jeunes/QuestionsUsers';
import Result from './Pages/Jeunes/Result';
import AboutUsJeunes from './Pages/Jeunes/AboutUsJeunes';
//Pages Parents
import HomeAdult from './Pages/Parents/HomeAdults';
import AllArticlesParents from './Pages/Parents/AllArticlesParents';
import QuestionUserParent from "./Pages/Parents/QuestionUserParent";
import SpecificArticle from './Pages/Parents/SpecificArticle';
//Page Relais
import HomeRelay from './Pages/Relay/HomeRelay';
import RessourcesRelais from './Pages/Relay/RessourcesRelais';
//Page transverse
import PartnersPage from './Pages/PartnersPage';
import AboutUsPage from './Pages/AboutUsPage';
// 404
import NotFound from './Pages/NotFoundPage';

//Composants
import Footer from './components/Footer';
import { useUser } from './Hook/useUser';

function App() {
	const {updateUser} = useUser();

	useEffect(() => {
		const handleUrlChange = () => {
			const location = window.location.href;
			if (location.includes('Parents')) {
			  updateUser('parent');
			} else if (location.includes('/Relais')) {
			  updateUser('relai');
			} else {
			  updateUser('young');
			}
		  };
			// Écoutez les changements d'URL lors du chargement de la page à partir de l'historique du navigateur
			window.addEventListener('popstate', handleUrlChange);

			// Nettoyez l'écouteur d'événements lors du démontage du composant
			return () => {
			window.removeEventListener('popstate', handleUrlChange);
			};
	}, [updateUser])

	return (
		<div className="App">
			<Router>
				<ScrollToTop />
				<ScrollToHashElement />				
				<NavbarHeader />
				<Routes>
					{/*Routes Jeunes*/}
					<Route path="/" element={<HomeYoung />} />
					<Route path="/Jeunes/ToutSurLesRegles" element={<AllOnPeriods />} />
					<Route path="/video/:title/:id" element={<SpecificVideo />} />
					<Route path="/Jeunes/QuestionsUtilisateurs" element={<QuestionsUsers parent={false} />} />
					<Route path="/Jeunes/Resultats" element={<Result />} />
					<Route path="/Jeunes/AboutUs" element={<AboutUsJeunes />} />
					{/*Routes Parents*/}
					<Route path="/Parents" element={<HomeAdult />} />
					<Route path="/Parents/QuestionsUtilisateurs" element={<QuestionUserParent />} />
					<Route path="/Parents/AllArticles" element={<AllArticlesParents />} />
					<Route path="/article/:title/:id" element={<SpecificArticle />} />
					{/*Routes Relais*/}
					<Route path="/Relais" element={<HomeRelay />} />
					<Route path="/Relais/Ressources" element={<RessourcesRelais />} />

					{/*Routes Communes*/}
					<Route path="/Partenaires" element={<PartnersPage />} />
					<Route path="/AboutUs" element={<AboutUsPage />} />

					{/*404*/}
					<Route path="*" element={<NotFound />}/>
				</Routes>
				<Footer />
			</Router>
		</div>
	);
}

export default App;
